<template>
  <div class="footer-container" :style="{ top: top + 'px' }">
    <div class="menu-item">
      <div class="icon home" :class="{ active: curActive === 'home' }" @click="navTo('home')"></div>
      <div class="text">首页</div>
    </div>
    <div class="menu-item">
      <div class="icon literature" :class="{ active: curActive === 'literature' }" @click="navTo('literature')"></div>
      <div class="text">文献</div>
    </div>
    <div class="menu-item">
      <el-dropdown @command="clickItem" ref="dropdown">
        <div class="icon user"></div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="c">我的收藏</el-dropdown-item>
          <el-dropdown-item command="a">登录</el-dropdown-item>
          <el-dropdown-item command="b">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="text">{{ userInfo.name ? userInfo.name.slice(0, 2) : '游客' }}</div>
    </div>
    <login ref="login" />
  </div>
</template>
<script>
import login from '@/components/login'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      top: (1080 / window.innerWidth) * window.innerHeight - 224
    }
  },
  components: {
    login
  },
  computed: {
    ...mapGetters(['userInfo']),
    curActive () {
      return this.$route.name
    }
  },
  methods: {
    clickItem (key) {
       if (key === 'a') this.openLogin()
       if (key === 'b') this.logOut()
      if (key === 'c') this.$router.push({ name: 'collection' })
      this.$nextTick(() => {
        this.$refs.dropdown.hide()
      })
    },
    navTo (key) {
      this.$router.push({ name: key })
    },
    openLogin () {
      this.$refs.login.open()
    },
    logOut () {
      this.$store.dispatch('logOut').then(() => {
        this.$router.push('/home')
      })
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
@import "~@/styles/variables.less";
.footer-container {
  position: absolute;
  width: 1080px;
  height: 224px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 196px;
  background: #7c1823;
  color: white;
  font-family: FangZhengKaiTi-GBK;
  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon {
      width: 96px;
      height: 96px;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .home {
      background-image: url("~@/assets/images/footer-home.png");
      &.active {
        background-image: url("~@/assets/images/footer-home-active.png");
      }
    }
    .literature {
      background-image: url("~@/assets/images/footer-literature.png");
      &.active {
        background-image: url("~@/assets/images/footer-literature-active.png");
      }
    }
    .user {
      background-image: url("~@/assets/images/footer-user.png");
    }
    .text {
      color: #f5f2eb;
      font-size: 36px;
      line-height: 43px;
    }
  }
}
</style>
